import React from 'react';
import { LayoutSingleColumn, NamedLink, Page, PrimaryButton } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { FormattedMessage, useIntl } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';

import css from './TermsOfUsePage.module.css';
import { useConfiguration } from '../../context/configurationContext';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const TermsOfUsePageComponent = props => {
  const { scrollingDisabled } = props;

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'TermsOfUsePage.title' });

  const config = useConfiguration();
  const vatNumber = config.vatNumber;

  const history = useHistory();

  return (
    <Page
      title={title}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="TermsOfUsePage" />
          </>
        }
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <h1 className={css.h1}>Music Marmalade Website Terms of Use</h1>
          <h2 className={css.h2}>
            About these Terms
            <hr />
          </h2>
          <ul id={css.l1} className={css.discList}>
            <li>
              <p className={css.p}>
                These terms apply to your access and use of the Music Marmalade website (the
                <b> Website</b>). You should also review our{' '}
                <NamedLink name="PrivacyPolicyPage">Privacy Policy</NamedLink> which explains what
                personal data we collect when you use our website.
              </p>
            </li>
            <li>
              <p className={css.p}>
                By accessing our Website, you acknowledge that these terms are legally binding. If
                you don’t agree with any of these terms, you should stop accessing and using our
                Website.
              </p>
            </li>
          </ul>

          <ol className={css.orderList}>
            <li>
              <h2 className={css.h2}>
                About Us
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    We are Entium Platforms Ltd (trading as Music Marmalade), a company registered
                    in Scotland under company registration number SC797777. Our registered office is
                    at Unit A7 Somervell Trading Estate, Somervell Street, Cambuslang, Glasgow, G72
                    7EB. Our VAT registration number is {vatNumber}.
                  </p>
                </li>
                <li className={css.itemNestedList}>
                  <div>If you have any questions about the Website, please contact us by:</div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>
                        sending an email to{' '}
                        <a
                          href="mailto:hello@musicmarmalade.com"
                          className={css.link}
                          target="_blank"
                          name="bookmark3"
                          rel="noreferrer"
                        >
                          hello@musicmarmalade.com
                        </a>
                        &nbsp;or
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        filling out and submitting the online form available{' '}
                        <NamedLink name="ContactUsPage">
                          <FormattedMessage id="General.here" />
                        </NamedLink>
                        .
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Using the Website
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    We reserve the right to suspend the operation of our Website at any time. We may
                    also restrict access to some parts of our Website to users who have registered
                    with us.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    You are responsible for maintaining your own internet connection for accessing
                    the Website.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    We may prevent or suspend your access to the Website if you do not comply with
                    these terms or any applicable law.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    We may suspend or terminate access or operation of the Website at any time as we
                    see fit.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    We do not promise that the Website will be available at all times or that your
                    use of the Website will be uninterrupted.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    Whilst we require all users to comply with these Website Terms of Use, we cannot
                    guarantee that all materials uploaded to the Website by other users will comply
                    with these Terms of Use. We will endeavour to remove content that is deemed by
                    us to be in breach of these Terms of Use, but accept no liability for content
                    that users may find to be offensive, harmful, inaccurate or deceptive.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    Users should exercise caution when interacting with others either via the
                    Website or who they come into contact with as a result of their use of the
                    Website. Music Marmalade does not, and is under no obligation to, undertake any
                    identity or criminal record checks of anyone that uses the Website including
                    Clients and Artists.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                User Account and Password Security
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li className={css.itemNestedList}>
                  <div>
                    If you need a username or password to access any part of our Website you agree
                    to:
                  </div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>ensure that any details provided to us are accurate;</p>
                    </li>
                    <li>
                      <p className={css.p}>
                        keep your username or password secure and confidential; and
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        let us know promptly if you believe that your username or password has been
                        compromised.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p className={css.p}>
                    We may terminate your access to any Website or any password-protected areas of
                    our Website at any time, if we believe that your use of our Website is affecting
                    the security and stability of our Website or is detrimental to other users.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Intellectual Property Rights
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    The intellectual property rights in the Website and in any text, images, video,
                    audio or other multimedia content, software or other information or material
                    submitted to or accessible from the Website (Content) are owned by us and our
                    licensors.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    We and our licensors reserve all our intellectual property rights (including,
                    but not limited to, all copyright, trademarks, domain names, design rights,
                    database rights, patents and all other intellectual property rights of any kind)
                    whether registered or unregistered anywhere in the world. This means, for
                    example, that we remain owners of them and are free to use them as we see fit.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    Nothing in these terms grants you any legal rights in the Website or the Content
                    other than as necessary for you to access it.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    You may not use any trademarks or trade names that are displayed on this
                    Website, unless you have our express written permission.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Information on the website
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    We try to make sure that the Website is accurate, up-to-date and free from bugs,
                    but we do not guarantee that it will be.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    We do not guarantee that the Website will be fit or suitable for any particular
                    purpose. Any reliance that you may place on the information on the Website is at
                    your own risk.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Third party Sites
                <hr />
              </h2>

              <ol id={css.l10} className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    We have no control over, and don’t accept any responsibility for, the content of
                    any third party website. If we link to any third party website, this doesn’t
                    mean that we endorse or recommend the organisation which operates it. Your use
                    of a third party site may be governed by the terms and conditions of that
                    third-party site and is at your own risk.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Acceptable Use
                <hr />
              </h2>

              <ol id={css.l11} className={css.nestedOrderList}>
                <li className={css.itemNestedList}>
                  <div>You may not use our site:</div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>If you are under the age of 18.</p>
                    </li>
                    <li>
                      <p className={css.p}>
                        In any way that breaches any applicable local, national or international law
                        or regulation.
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        In any way that is unlawful or fraudulent or has any unlawful or fraudulent
                        purpose or effect.
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        To bully, insult, intimidate, harm or humiliate any person.
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        To transmit, or procure the sending of, any unsolicited or unauthorised
                        advertising or promotional material or any other form of similar
                        solicitation (spam).
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        To knowingly transmit any data, send or upload any material that contains
                        viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware,
                        adware or any other harmful programs or similar computer code designed to
                        adversely affect the operation of any computer software or hardware.
                      </p>
                    </li>
                  </ol>
                </li>
                <li className={css.itemNestedList}>
                  <div>You also agree:</div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>
                        Not to reproduce, duplicate, copy or re-sell any part of our site.
                      </p>
                    </li>
                    <li className={css.itemNestedList}>
                      <div>Not to access without authority, interfere with, damage or disrupt:</div>
                      <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                        <li>
                          <p className={css.p}>any part of our site;</p>
                        </li>
                        <li>
                          <p className={css.p}>
                            any equipment or network on which our site is stored;
                          </p>
                        </li>
                        <li>
                          <p className={css.p}>
                            any software used in the provision of our site; or
                          </p>
                        </li>
                        <li>
                          <p className={css.p}>
                            any equipment or network or software owned or used by any third party.
                          </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Content Standards
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    These content standards apply to any and all material which you contribute to
                    our site (<b>Contribution</b>).
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    The Content Standards must be complied with in spirit as well as to the letter.
                    The standards apply to each part of any Contribution as well as to its whole.
                  </p>
                </li>
                <li>
                  <p className={css.p}>
                    Music Marmalade will determine, in its discretion, whether a Contribution
                    breaches the Content Standards.
                  </p>
                </li>
                <li className={css.itemNestedList}>
                  <div>A Contribution must:</div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>be accurate (where it states facts).</p>
                    </li>
                    <li>
                      <p className={css.p}>only contain opinions that are genuinely held.</p>
                    </li>
                    <li>
                      <p className={css.p}>
                        comply with the law applicable in any country from which it is posted and to
                        which the website is targeted.
                      </p>
                    </li>
                  </ol>
                </li>
                <li className={css.itemNestedList}>
                  <div>A Contribution must not:</div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>Be defamatory of any person.</p>
                    </li>
                    <li>
                      <p className={css.p}>
                        Be obscene, offensive, hateful, discriminatory, untruthful or inflammatory.
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>Bully, insult, intimidate or humiliate.</p>
                    </li>
                    <li>
                      <p className={css.p}>Promote or include sexually explicit material.</p>
                    </li>
                  </ol>
                </li>
                <li className={css.itemNestedList}>
                  <div>
                    For the avoidance of doubt, for any Contribution in the form of video content:
                  </div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>
                        You must tell us immediately, if you upload a video containing any of the
                        following: criminal material (relating to terrorism, sexual exploitation of
                        children, child pornography, racism and xenophobia), unclassified or
                        unclassifiable videos, videos rated R18 or suitable for R18 rating and other
                        material that might impair the physical, mental or moral development of
                        persons under the age of 18 (restricted material).
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        You must not upload a video containing harmful material.
                      </p>
                    </li>
                    <li className={css.itemNestedList}>
                      <div>
                        You must not upload a video containing advertising for any of the following:
                      </div>
                      <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                        <li>
                          <div>
                            cigarettes and other tobacco products, electronic cigarettes or
                            electronic cigarette refill containers, and prescription-only medicine;
                            or
                          </div>
                        </li>
                        <li>
                          <div>
                            for alcoholic drinks that are not aimed specifically at under 18s and do
                            not encourage immoderate consumption of alcohol.
                          </div>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Limit of Liability
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li className={css.itemNestedList}>
                  <div>
                    Except for any legal responsibility that we cannot exclude in law (such as for
                    death or personal injury) or arising under applicable laws relating to the
                    protection of your personal information, we are not legally responsible for any:
                  </div>
                  <ol className={classNames(css.nestedOrderList, css.secondNestedOrderList)}>
                    <li>
                      <p className={css.p}>
                        losses that were not foreseeable to you and us when these terms were formed;
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>
                        losses that were not caused by any breach on our part;
                      </p>
                    </li>
                    <li>
                      <p className={css.p}>business losses; and</p>
                    </li>
                    <li>
                      <p className={css.p}>losses to non-consumers.</p>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Variation to these terms
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    We reserve the right to amend these terms. Our updated terms will be displayed
                    on the Website. By continuing to use and access the Website, you agree to be
                    bound by any future updates to these terms as and when they are updated. It is
                    your responsibility to check these terms from time to time to verify such
                    variations.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Complaints and Queries
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    If you have any questions about our Website, or have any complaints about its
                    contents, please contact us&nbsp;
                    <NamedLink name="ContactUsPage">
                      <FormattedMessage id="General.here" />
                    </NamedLink>
                    .
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h2 className={css.h2}>
                Law and Jurisdiction
                <hr />
              </h2>

              <ol className={css.nestedOrderList}>
                <li>
                  <p className={css.p}>
                    The laws of England and Wales apply to these terms. Any disputes will be subject
                    to the exclusive jurisdiction of the courts of England and Wales, unless you are
                    a consumer and live in either Northern Ireland or Scotland. In which case, you
                    can choose to bring a claim in England and Wales or in the courts of another
                    part of the UK in which you live.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <p />
          <PrimaryButton type="button" onClick={() => history.goBack()}>
            {intl.formatMessage({ id: 'General.goBack' })}
          </PrimaryButton>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TermsOfUsePage = compose(
  withRouter,
  connect(mapStateToProps)
)(TermsOfUsePageComponent);

export default TermsOfUsePage;
